import React from 'react'
import ButtonBase from './ButtonBase'

export interface ButtonLinkProps {
  children: React.ReactNode
  disabled?: boolean
  onClick?: () => void
  className?: string
  fullWidth?: boolean
  icon?: React.ReactNode
  iconPosition?: 'left' | 'right'
  style?: React.CSSProperties
  'data-testid'?: string
}

const ButtonLink: React.FC<ButtonLinkProps> = ({
  children,
  disabled = false,
  onClick,
  className = '',
  fullWidth = false,
  icon,
  iconPosition = 'left',
  style,
  'data-testid': dataTestId
}) => {
  const iconElement = icon && <span className="flex items-center justify-center">{icon}</span>

  return (
    <ButtonBase
      disabled={disabled}
      onClick={onClick}
      fullWidth={fullWidth}
      style={style}
      data-testid={dataTestId}
      className={`
        shadow-none hover:shadow-none focus:shadow-none active:shadow-none
        text-sun hover:text-sun-60 focus:ring-sun/20 
        disabled:text-white-30 bg-transparent border-0 p-0 h-auto
        flex items-center justify-center
        ${className}
      `}
    >
      {iconPosition === 'left' && iconElement}
      {iconPosition === 'left' && icon && <span className="ml-2">{children}</span>}
      {!icon && children}
      {iconPosition === 'right' && icon && <span className="mr-2">{children}</span>}
      {iconPosition === 'right' && iconElement}
    </ButtonBase>
  )
}

export default ButtonLink
